import {Outlet} from "react-router-dom";
import {Container, Stack} from "@mui/system";
import {Card, CardContent, CardMedia} from "@mui/material";
import cardImage from '../asset/3CSC_INTL.png';

function Layout() {
  return (
    <Container
      maxWidth={false}
      sx={{
        minWidth: "350px",
        maxWidth: "450px",
        maxHeight: "542px",
        padding: 4,
      }}
    >
      <Card
        variant="outlined"
      >
        <CardContent>
          <Stack
            direction="column"
            spacing={3}
            alignItems="left"
            justifyContent="flex-start"
            component="form"
          >
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="space-between"
            >
              <CardMedia
                style={{
                  width: "auto",
                  objectFit: 'contain'
                }}
                component="img"
                image="https://www.aexp-static.com/cdaas/one/statics/axp-static-assets/2.24.1/package/dist/img/logos/dls-logo-stack.svg"
                alt="American Express"
              />
              <CardMedia
                style={{
                  width: 93,
                  height: "auto",
                  objectFit: 'contain'
                }}
                component="img"
                image={cardImage}
                alt="American Express Card"
              />
            </Stack>
            <Outlet />
          </Stack>
        </CardContent>
      </Card>
    </Container>
  );
}

export default Layout;
